import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import { redoCustomerIdFields } from "../common-fields";

export const customEventSchema = defineSchema({
  fields: {
    ...redoCustomerIdFields,
    customerEmail: {
      dataType: "Maybe Email",
      documentation: "The email address of the customer.",
    },
    customerPhone: {
      dataType: "Maybe Phone",
      documentation: "The phone number of the customer.",
    },
    customerFirstName: {
      dataType: "Maybe Text",
      documentation: "The first name of the customer.",
      hideFromConditionStep: true,
    },
    customerLastName: {
      dataType: "Maybe Text",
      documentation: "The last name of the customer.",
      hideFromConditionStep: true,
    },
    eventName: {
      dataType: "Text",
      documentation:
        "The name of the custom event (e.g., 'user_registered', 'purchase_completed').",
    },
    eventTimestamp: {
      dataType: "Maybe DateTime",
      documentation: "The timestamp when the event occurred.",
    },
    properties: {
      dataType: "Object",
      documentation:
        "Custom properties associated with this event. Access nested properties using dot notation (e.g., {{ properties.product_name }}).",
    },
    cartContext: {
      dataType: "Cart Context",
      documentation:
        "Data that is useful for generating product recommendations for an interactive cart.",
    },
  },
});

export const exampleCustomEventSchemaInstance: SchemaInstance<
  typeof customEventSchema
> = {
  redoCustomerId: "507f1f77bcf86cd799439011",
  customerEmail: "customer@example.com",
  customerPhone: "+15555551234",
  customerFirstName: "Jane",
  customerLastName: "Doe",
  eventName: "order_created",
  eventTimestamp: Temporal.Now.instant(),
  properties: {
    order_id: "1234567890",
    order_total: 10_000,
    order_status: "completed",
    order_currency: "USD",
    order_date: "2021-01-01",
    order_products: [
      {
        product_id: "1234567890",
        product_name: "Product Name",
        product_price: 10_000,
      },
      {
        product_id: "1234567891",
        product_name: "Product Name 2",
        product_price: 20_000,
      },
    ],
  },
  cartContext: {
    existingCartId: null,
    productIdsForRecommendations: [],
    alreadyInCart: [],
  },
};
